export var container = 'c5-10-0_mmm1dv0 c5-10-0_nly6ul4';
export var containerSize = {sm:'c5-10-0_mmm1dv1',md:'c5-10-0_mmm1dv2',lg:'c5-10-0_mmm1dv3'};
export var spin = 'c5-10-0_mmm1dv5';